import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useKpis (organizations, startDate, endDate, previousStartDate, previousEndDate, timezone) {
  const organizationCodes = organizations.map((organization) => organization.OrganizationCode).join(',')
  return useQuery(['kpis', organizationCodes, startDate, endDate, previousStartDate, previousEndDate], async () => {
    const kpis = await axios.post(`${getApiServer()}/kpis`, { organizations: organizationCodes, startDate, endDate, previousStartDate, previousEndDate, timezone }, { withCredentials: true })
    return kpis.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}